import { render, staticRenderFns } from "./buyerOpenStoreOrderStatList.vue?vue&type=template&id=09594882&scoped=true&"
import script from "./buyerOpenStoreOrderStatList.vue?vue&type=script&lang=js&"
export * from "./buyerOpenStoreOrderStatList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09594882",
  null
  
)

export default component.exports